import React, { useState } from 'react';
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { reloadFilters } from 'features/filtersState';
import { DateRangePicker, DateRange } from 'date-range-picker-mui';
import dayjs from 'dayjs';
import DateRangeIcon from '@mui/icons-material/DateRange';

interface DateRangeComponentProps {
  dashboardId: string;
  filterId: string;
}

const DateRangeComponent: React.FC<DateRangeComponentProps> = ({
  dashboardId,
  filterId,
}) => {
  const dispatch = useDispatch();
  const [openDateRangePicker, setOpenDateRangePicker] = useState(false);
  const [dateRangeSelected, setDateRangeSelected] = useState<DateRange>({
    startDate: new Date('2023-04-01'),
    endDate: new Date('2023-04-30'),
  });

  const setDateRange = (range: DateRange) => {
    const selectedValues: { id?: string; name: string }[] = [
      {
        id: `${range.startDate?.toISOString()}|${range.endDate?.toISOString()}`,
        name: `${range.startDate?.toString()} to ${range.endDate?.toString()}`,
      },
      { id: 'daily', name: 'daily' },
    ];
    setDateRangeSelected(range);
    setOpenDateRangePicker(false);
    dispatch(
      reloadFilters({
        affectedFilters: [filterId],
        filterId: filterId,
        dashboardId,
        selectedValues,
        loaded: true,
      })
    );
  };

  const getStringValues = (range) => {
    return ` ${dayjs(range.startDate).format('DD/MM/YYYY')} to ${dayjs(
      range.endDate
    ).format('DD/MM/YYYY')}`;
  };

  return (
    <div className="date-range-filter">
      <FormControl variant="outlined">
        <OutlinedInput
          id="outlined-adornment-password"
          type={'text'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setOpenDateRangePicker(true)}
                edge="end"
              >
                <DateRangeIcon />
              </IconButton>
            </InputAdornment>
          }
          label="Password"
          value={getStringValues(dateRangeSelected)}
        />
      </FormControl>
      <div className="date-range-picker">
        <DateRangePicker
          open={openDateRangePicker}
          toggle={() => {}}
          onChange={(range) => setDateRange(range)}
          initialDateRange={dateRangeSelected}
          closeOnClickOutside={true}
        />
      </div>
    </div>
  );
};

export default DateRangeComponent;
